import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function usEinValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;

    // Stored values predate this rule and may contain dashes. Leave them alone until the user
    // actually edits the field — otherwise an old record opens with a red box, no message, and a
    // Continue button that stays disabled with nothing explaining why.
    if (control.pristine) return null;

    // Digits only, 9 to 11 of them — the same rule the API enforces on TaxNumber. Values that
    // merely look like placeholders (111111111) are accepted; Stripe is the authority on whether
    // the number is real.
    return /^\d{9,11}$/.test(value) ? null : { invalidUsEin: true };
  };
}
